<template>
  <span class="relative">
    <span>{{ tab.name }}</span>
    <img
      class="w-4 h-4 ml-1 inline-block"
      src="@/assets/icons/Moloch-01.png"
      v-if="state.selectedPlatform === 'moloch'"
    />
    <img
      class="w-4 h-4 ml-1 inline-block"
      src="@/assets/icons/RetroPGF-01.png"
      v-if="state.selectedPlatform === 'retropgf'"
    />
    <span
      v-else
      class="iconfont z-top cursor-pointer w-4 h-4 ml-1"
      :class="platformIconOnlyStyle(state.selectedPlatform)"
    ></span>
    <div class="absolute -right-5" style="top: 15%">
      <el-dropdown
        trigger="click"
        v-if="tab.platforms?.length > 1"
        placement="bottom"
        @command="handleClick"
      >
        <span
          class="el-dropdown-link text-whitebase iconfont"
          :class="{ 'icon-right': !state.isOpen, 'icon-xia1': state.isOpen }"
        >
        </span>
        <template #dropdown>
          <el-dropdown-menu>
            <el-dropdown-item
              v-for="(platform, i) in tab.platforms"
              :key="i"
              :command="platform"
              >{{ platform }}</el-dropdown-item
            >
          </el-dropdown-menu>
        </template>
      </el-dropdown>
    </div>
  </span>
</template>
<script setup>
import { inject, onMounted, reactive, ref, watch, computed } from 'vue';
import { platformIconOnlyStyle } from '@/constants/platforms';
const props = defineProps({ tab: Object });
const emits = defineEmits(['platformChange']);

const state = reactive({
  selectedTab: null,
  selectedPlatformIndex: 0,
  selectedPlatform: null,
  isOpen: false,
  menu: [0, 0],
});
const handleClick = (a) => {
  state.selectedPlatform = a;
};
onMounted(() => {
  watch(
    () => state.selectedPlatform,
    () => {
      if (state.selectedPlatform) {
        emits('platformChange', props.tab.name, state.selectedPlatform);
      }
    },
  );
  state.selectedPlatform = props.tab.platforms[0];
  watch(
    () => props.tab,
    () => {
      state.selectedPlatform = props.tab.platforms[0];
    },
  );
});
</script>
<style></style>
